module.exports = __webpack_public_path__ + "static/18(3)-deae4d2155742c36c41198ff6a679df3.jpg";